import React, { useContext } from "react";
import { Nav } from "react-bootstrap";
import { NavLink, useLocation } from "react-router-dom";
import { TenantContext } from '../../tenant/TenantContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faHandHoldingDollar, faCreditCard,
  faDiagramProject, faSignature, faHistory,
  faPeopleGroup, faCalendarCheck, faList, faKey, faUserPlus, faHandshake, faFileInvoiceDollar,
  faBriefcaseClock, faLandmark, faChartLine, faMoneyBillWave, faHome, faHandsHoldingChild, faUsers,
  faWallet, faGift
} from '@fortawesome/free-solid-svg-icons'
import { SecurityContext } from '../../security/SecurityContext';
import _ from "lodash";

function Sidebar(props) {
  const { businessConfig } = useContext(TenantContext);
  const location = useLocation();
  //const sidebarImage = process.env.PUBLIC_URL + "/branding" + businessConfig.sidebarImage;
  const sidebarImage = process.env.REACT_APP_BASE_API_URL + "/businesses/brandelements/sidebarimage"
  const sidebarColor = businessConfig.sidebarColor;
  const sidebarFontColor = businessConfig.sidebarFontColor;
  //const logoImage = process.env.PUBLIC_URL + "/branding" + businessConfig.logo;
  const logoImage = process.env.REACT_APP_BASE_API_URL + "/businesses/brandelements/logo"
  const secCtx = useContext(SecurityContext);

  const activeRoute = (routeName) => {
    return location.pathname.indexOf(routeName) > -1 ? "active" : "";
  };

  return (
    <div className="sidebar" data-image={sidebarImage} data-color={sidebarColor}>
      <div
        className="sidebar-background"
        style={{
          backgroundImage: "url(" + sidebarImage + ")",
        }}
      />
      <div className="sidebar-wrapper">
        <div className="logo d-flex align-items-center justify-content-start">
          <a
            href={businessConfig.url}
            className="simple-text logo-mini mx-1"
          >
            <div>
              <img src={logoImage} alt="..." height={businessConfig.logoHeight} width={businessConfig.logoWidth} />
            </div>
          </a>
        </div>
        <div className="logo d-flex align-items-center justify-content-start">
          <a href={businessConfig.url} style={{ color: sidebarFontColor }}>
            <div style={{ color: sidebarFontColor }}>
              {businessConfig.name}
            </div>
          </a>
        </div>
        <Nav>
          {secCtx.authState && <li className={activeRoute("/home")}>
            <NavLink className="nav-link" to="/home">
              <div style={{ color: sidebarFontColor }}>
                <FontAwesomeIcon size="2x" icon={faHome} className="me-3" /> Home
              </div>
            </NavLink>
          </li>}
          {/*Business Admin NavNavLinks*/}
          {secCtx.authState && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN") && !secCtx.profile.passwordExpired &&
            <React.Fragment>
              {businessConfig.appFeatures.includes('BILLING') &&
                <React.Fragment>
                  <li className={activeRoute("/businessbills")}>
                    <NavLink className="nav-link" to="/businessbills">
                      <div style={{ color: sidebarFontColor }}>
                        <FontAwesomeIcon size="2x" icon={faFileInvoiceDollar} className="me-3" /> Bills
                      </div>
                    </NavLink>
                  </li>
                  <li className={activeRoute("/businessaccounttypes")}>
                    <NavLink className="nav-link" to="/businessaccounttypes">
                      <div style={{ color: sidebarFontColor }}>
                        <FontAwesomeIcon size="2x" icon={faList} className="me-3" /> Account Types
                      </div>
                    </NavLink>
                  </li>
                </React.Fragment>}
              <li className={activeRoute("/businessaccounts")}>
                <NavLink className="nav-link" to="/businessaccounts">
                  <div style={{ color: sidebarFontColor }}>
                    <FontAwesomeIcon size="2x" icon={faHandshake} className="me-3" /> Accounts
                  </div>
                </NavLink>
              </li>
              <li className="mb-1">
                <NavLink className="nav-link" to="/payment-history">
                  <div style={{ color: sidebarFontColor }}>
                    <FontAwesomeIcon size="2x" className="me-3" icon={faHistory} /> Payment History
                  </div>
                </NavLink>
              </li>
              <li className="mb-1">
                <NavLink className="nav-link" to="/recurring-payments">
                  <div style={{ color: sidebarFontColor }}>
                    <FontAwesomeIcon size="2x" className="me-3" icon={faBriefcaseClock} /> Recurring Payments
                  </div>
                </NavLink>
              </li>
              {(businessConfig.type === 'NON_PROFIT') && (businessConfig.appFeatures.includes('DONATION_MANAGEMENT')) &&
                <React.Fragment>
                  <li className={activeRoute("/businessdonationcauses")}>
                    <NavLink className="nav-link" to="/businessdonationcauses">
                      <div style={{ color: sidebarFontColor }}>
                        <FontAwesomeIcon size="2x" icon={faHandHoldingDollar} className="me-3" /> Donation Causes
                      </div>
                    </NavLink>
                  </li>
                  {businessConfig.appFeatures.includes('SPONSORSHIP_MANAGEMENT') &&
                    <React.Fragment>
                      <li className={activeRoute("/businesssponsorships")}>
                        <NavLink className="nav-link" to="/businesssponsorships">
                          <div style={{ color: sidebarFontColor }}>
                            <FontAwesomeIcon size="2x" icon={faHandHoldingDollar} className="me-3" /> Sponsorships
                          </div>
                        </NavLink>
                      </li>
                      <li className={activeRoute("/business-sponsors")}>
                        <NavLink className="nav-link" to="/business-sponsors">
                          <div style={{ color: sidebarFontColor }}>
                            <FontAwesomeIcon size="2x" icon={faHandsHoldingChild} className="me-3" /> Sponsors
                          </div>
                        </NavLink>
                      </li>
                    </React.Fragment>}
                  <li className={activeRoute("/user-donation")}>
                    <NavLink to="/user-donation" className="nav-link">
                      <div style={{ color: sidebarFontColor }}>
                        <FontAwesomeIcon size="2x" icon={faHandHoldingDollar} className="me-3" />
                        <p>Donate/Sponsor</p>
                      </div>
                    </NavLink>
                  </li>
                  <li className={activeRoute("/businesspromotions")}>
                    <NavLink className="nav-link" to="/businesspromotions">
                      <div style={{ color: sidebarFontColor }}>
                        <FontAwesomeIcon size="2x" icon={faGift} className="me-3" /> Promotions
                      </div>
                    </NavLink>
                  </li>

                </React.Fragment>}


              <li className={activeRoute("/businessmessages")}>
                <NavLink className="nav-link" to="/businessmessages">
                  <div style={{ color: sidebarFontColor }}>
                    <FontAwesomeIcon size="2x" icon={faLandmark} className="me-3" /> Messages
                  </div>
                </NavLink>
              </li>
              <li className={activeRoute("/businessusers")}>
                <NavLink className="nav-link" to="/businessusers">
                  <div style={{ color: sidebarFontColor }}>
                    <FontAwesomeIcon size="2x" icon={faUsers} className="me-3" /> User Admin
                  </div>
                </NavLink>
              </li>
              <li className={activeRoute("/business-resetpassword")}>
                <NavLink className="nav-link" to="/business-resetpassword">
                  <div style={{ color: sidebarFontColor }}>
                    <FontAwesomeIcon size="2x" icon={faUsers} className="me-3" /> Reset Customer Password
                  </div>
                </NavLink>
              </li>
              <li className={activeRoute("/business-paymentcards")}>
                <NavLink className="nav-link" to="/business-paymentcards">
                  <div style={{ color: sidebarFontColor }}>
                    <FontAwesomeIcon size="2x" icon={faCreditCard} className="me-3" /> Update Credit Card
                  </div>
                </NavLink>
              </li>
            </React.Fragment>
          }
          {secCtx.authState && (secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN") || secCtx.profile.roles.includes("ROLE_DONATION_BOX"))
            && (businessConfig.type === 'NON_PROFIT')
            && (businessConfig.appFeatures.includes('DONATION_MANAGEMENT')) &&
            <li className={activeRoute("/businessdonationboxes")}>
              <NavLink to="/businessdonationboxes" className="nav-link">
                <div style={{ color: sidebarFontColor }}>
                  <FontAwesomeIcon size="2x" icon={faHandHoldingDollar} className="me-3" />
                  <p>Donation Box</p>
                </div>
              </NavLink>
            </li>}
          {(businessConfig.type === 'NON_PROFIT') && secCtx.authState && secCtx.profile.roles.includes("ROLE_BUSINESS_ADMIN")
            && (businessConfig.appFeatures.includes('DONATION_MANAGEMENT')) &&
            <React.Fragment>
              <div className="logo d-flex align-items-center justify-content-start">
                <div style={{ color: sidebarFontColor }}>
                  Reports
                </div>
              </div>
              <li className="mb-1">
                <NavLink className="nav-link" to="/businesspmtreportbydoncause">
                  <div style={{ color: sidebarFontColor }}>
                    <FontAwesomeIcon size="2x" className="me-3" icon={faChartLine} /> Payments by Donation Cause
                  </div>
                </NavLink>
              </li>
            </React.Fragment>}

          {/*Authenticated Customer Links*/}
          {secCtx.authState && secCtx.profile.roles.includes("ROLE_CONSUMER") && !secCtx.profile.passwordExpired &&
            <React.Fragment>
              <li className={activeRoute("/wallet")}>
                <NavLink to="/wallet" className="nav-link">
                  <div style={{ color: sidebarFontColor }}>
                    <FontAwesomeIcon size="2x" icon={faWallet} className="me-3" />
                    <p>My Payment Cards</p>
                  </div>
                </NavLink>
              </li>
              {(businessConfig.type === 'NON_PROFIT') && (businessConfig.appFeatures.includes('DONATION_MANAGEMENT')) &&
                <>
                  <li className={activeRoute("/user-donation")}>
                    <NavLink to="/user-donation" className="nav-link">
                      <div style={{ color: sidebarFontColor }}>
                        <FontAwesomeIcon size="2x" icon={faHandHoldingDollar} className="me-3" />
                        <p>Donate/Sponsor</p>
                      </div>
                    </NavLink>
                  </li>
                  {businessConfig.appFeatures.includes('SPONSORSHIP_MANAGEMENT') &&
                    <li className={activeRoute("/user-sponsorships")}>
                      <NavLink to="/user-sponsorships" className="nav-link">
                        <div style={{ color: sidebarFontColor }}>
                          <FontAwesomeIcon size="2x" icon={faHandsHoldingChild} className="me-3" />
                          <p>My Sponsorships</p>
                        </div>
                      </NavLink>
                    </li>}
                  {(businessConfig.appFeatures.includes('DONATION_MANAGEMENT')) && <li className="mb-1">
                    <NavLink className="nav-link" to="/oneclick-payments">
                      <div style={{ color: sidebarFontColor }}>
                        <FontAwesomeIcon size="2x" className="me-3" icon={faMoneyBillWave} /> One Click Payments
                      </div>
                    </NavLink>
                  </li>}


                </>}

              <li className="mb-1">
                <NavLink className="nav-link" to="/recurring-payments">
                  <div style={{ color: sidebarFontColor }}>
                    <FontAwesomeIcon size="2x" className="me-3" icon={faBriefcaseClock} /> Recurring Payments
                  </div>
                </NavLink>
              </li>
              <li className="mb-1">
                <NavLink className="nav-link" to="/payment-history">
                  <div style={{ color: sidebarFontColor }}>
                    <FontAwesomeIcon size="2x" className="me-3" icon={faHistory} /> Payment History
                  </div>
                </NavLink>
              </li>
              {businessConfig.appFeatures.includes('BILLING') && !_.isEmpty(businessConfig.accountTypes) && !_.isEmpty(secCtx.accounts)
                && <React.Fragment>
                  <div className="logo d-flex align-items-center justify-content-start">
                    <div style={{ color: sidebarFontColor }}>
                      Accounts
                    </div>
                  </div>
                  {businessConfig.accountTypes.map((accountType, idx1) => (
                    <React.Fragment key={idx1}>
                      {secCtx.accounts.map((account, idx2) => (
                        <React.Fragment key={idx2}>
                          {(account.accountTypeId === accountType.id) && (accountType.accountType !== 'DONATION') &&
                            <li className="mb-1">
                              <NavLink className="nav-link" to={"/user-bills/" + account.id}>
                                <div style={{ color: sidebarFontColor }}>
                                  <FontAwesomeIcon size="2x" className="me-3" icon={faHandshake} /> {accountType.accountTypeDisplayName}
                                </div>
                              </NavLink>
                            </li>
                          }
                        </React.Fragment>
                      ))}
                    </React.Fragment>
                  ))}
                </React.Fragment>}

              {businessConfig.appFeatures.includes('SAVE_PAYMENT_CARD') &&
                <li className="mb-1">
                  <NavLink className="nav-link" to="/user-add-paymentcard">
                    <div style={{ color: sidebarFontColor }}>
                      <FontAwesomeIcon size="2x" className="me-3" icon={faCreditCard} /> Payment Methods
                    </div>
                  </NavLink>
                </li>}

              {businessConfig.appFeatures.includes('ESTIMATES_INVOICING') &&
                <li className="mb-1">
                  <NavLink className="nav-link" to="/user-estimates">
                    <div style={{ color: sidebarFontColor }}>
                      <FontAwesomeIcon size="2x" className="me-3" icon={faDiagramProject} /> Estimates
                    </div>
                  </NavLink>
                </li>
              }
              {businessConfig.appFeatures.includes('AGREEMENTS') &&
                <li className="mb-1">
                  <NavLink className="nav-link" to="/user-agreements">
                    <div style={{ color: sidebarFontColor }}>
                      <FontAwesomeIcon size="2x" className="me-3" icon={faSignature} />Agreements
                    </div>
                  </NavLink>
                </li>}

              {businessConfig.appFeatures.includes('MEMBER_FAMILY_MANAGEMENT') &&
                <li className="mb-1">
                  <NavLink className="nav-link" to="/user-family">
                    <div style={{ color: sidebarFontColor }}>
                      <FontAwesomeIcon size="2x" className="me-3" icon={faPeopleGroup} /> Family Members
                    </div>
                  </NavLink>
                </li>}

              {businessConfig.appFeatures.includes('APPOINTMENTS') &&
                <li className="mb-1">
                  <NavLink className="nav-link" to="/user-appointments">
                    <div style={{ color: sidebarFontColor }}>
                      <FontAwesomeIcon size="2x" className="me-3" icon={faCalendarCheck} /> Appointments
                    </div>
                  </NavLink>
                </li>}
            </React.Fragment>
          }


          {/*Unauthenticated Customer Links*/}
          {!secCtx.authState &&
            <React.Fragment>
              {(businessConfig.type === 'NON_PROFIT') && (businessConfig.appFeatures.includes('DONATION_MANAGEMENT')) &&
                <li className={activeRoute("/user-donation")}>
                  <NavLink to="/user-donation" className="nav-link">
                    <div style={{ color: sidebarFontColor }}>
                      <FontAwesomeIcon size="2x" icon={faHandHoldingDollar} className="me-3" />
                      <p>Donate</p>
                    </div>
                  </NavLink>

                </li>}
              <li className={activeRoute("/register-user")}>
                <NavLink to="/register-user" className="nav-link">
                  <div style={{ color: sidebarFontColor }}>
                    <FontAwesomeIcon size="2x" className="me-3" icon={faUserPlus} />
                    <p>Register</p>
                  </div>
                </NavLink>
              </li>
              <li className={activeRoute("/forgotpassword")}>
                <NavLink to="/forgotpassword" className="nav-link">
                  <div style={{ color: sidebarFontColor }}>
                    <FontAwesomeIcon size="2x" className="me-3" icon={faKey} />
                    <p>Reset Password</p>
                  </div>
                </NavLink>
              </li>
            </React.Fragment>
          }
        </Nav>
      </div>
    </div >
  );
}

export default Sidebar;
